<template>
	<div class="landing-home" v-if="pageHome.elements">

		<!-- CX2 -->
		<section id="contact-form" class="DIWM_contact-form container-fluid col-xs-12" v-in-viewport="">
			<div class="inner">


				<div class="inside">
					<div class="row">
						<div class="col-md-10 col-md-offset-1">
							<div class="row">
								<div class="col-md-6 col-lg-6">
									<h1>
										DIY<br/>
										Marketers:
									</h1>
								</div>
								<div class="col-md-6 col-lg-6">

								</div>
							</div>
							<div class="row">
								<div class="col-md-6 col-lg-6">


									<div class="subheadline">
										We all know Millennials are different. We’ll tell you what you don’t know.
									</div>

									<div class="text">
										<p>
											When you ask 2000+ homeowners (including Millennials) about their habits relative to DIY, their answers can be quite revealing.
										</p>
										<p>
											The largest segment of homeowners ever, Millennials are just entering homebuying age, and Marcus Thomas Chief Client Officer Mark Bachmann believes this 2019 study indicates that marketers need to <strong>"adjust preconceived notions about this segment."</strong>
										</p>
										<p>
											To schedule a 30-minute briefing on the full research report, just complete the form or contact Mark Bachmann, Chief Client Officer, via email or call 216.514.4544.
										</p>
									</div>
								</div>

								<div class="col-md-6 bg-contact">
									<div class="row">
										<div class="col-xs-12">
											<h3 class="text-center" v-in-viewport="">
												Schedule a Report Briefing
											</h3>
										</div>
										<div class="col-xs-12">
											<p class="text-small">* Required fields.</p>
										</div>
									</div>

									<div class="row">
										<form id="contactForm" @submit.prevent="validateForm('contactForm')" data-vv-scope="contactForm" action='https://crm.zoho.com/crm/WebToLeadForm' name=WebToLeads3285587000000345044 method='POST' accept-charset='UTF-8'  >
											<!-- Do not remove this code. -->
											<!-- <input type='text' style='display:none;' name='xnQsjsdp' value='f1c7c74f09065682e1d56ffe4c97645d08387b1b7086f4c6bb7118de4ad08959'/>
											<input type='hidden' name='zc_gad' id='zc_gad' value=''/>
											<input type='text' style='display:none;' name='xmIwtLD' value='4b98f2a03b7fb9570df3cb9573aed15de667c68fe354d55c2eaea21a740d85ee'/>
											<input type='text' style='display:none;'  name='actionType' value='TGVhZHM='/>
											<input type='text' style='display:none;' name='returnURL' value='http://newwebsite.mt.stage.mtllc.com/thank-you' />
											<input type='hidden' name='LEADCF3' id='LEADCF3' value='Campaign name' v-model="contactForm.campaign" data-vv-scope="contactForm"/>
											<input type='hidden' name='LEADCF1' id='LEADCF1' value='Do it with me - Contact form'/>
											-->


											<input type=hidden name='captcha_settings' value='{"keyname":"Captcha","fallback":"true","orgId":"00D6A0000038T85","ts":""}'>
											<input type=hidden name="oid" value="00D6A0000038T85">
											<input type=hidden name="retURL" value="http://">
											<input type=hidden name="Campaign_ID" value="7013u0000007aSHAAY">
											<input type=hidden name="lead_source" value="Website">


											<!-- Do not remove this code. -->

											<div class="form-row">
									      <div class="form-group col-md-6" :class="{error:errors.has('contactForm.first_name')}">
									        <span class="required" v-if="contactForm.first_name === ''">*</span>
									        <input type="text" class="form-control" id="first_name" maxlength='40' name='first_name' placeholder="First Name" v-validate="'required'" v-model="contactForm.first_name">
									        <span class="message-error" v-show="errors.has('contactForm.First Name')" >{{ errors.first('contactForm.first_name') }}</span>
									      </div>
									      <div class="form-group col-md-6" :class="{error:errors.has('contactForm.last_name')}">
									        <span class="required" v-if="contactForm.last_name === ''">*</span>
									        <input type="text" class="form-control"  id="last_name" maxlength='80' name='last_name' placeholder="Last Name" v-validate="'required'" v-model="contactForm.last_name">
									        <span class="message-error" v-show="errors.has('contactForm.Last Name')" >{{ errors.first('contactForm.last_name') }}</span>
									      </div>
									    </div>

									    <div class="form-row">
									      <div class="form-group col-md-6" :class="{error:errors.has('contactForm.company')}">
									        <span class="required" v-if="contactForm.company === ''">*</span>
									        <input type="text" class="form-control" id="company" maxlength='100' name='company' placeholder="Company" v-validate="'required'" v-model="contactForm.company">
									        <span class="message-error" v-show="errors.has('contactForm.Company')" >{{ errors.first('contactForm.Company') }}</span>
									      </div>
									      <div class="form-group col-md-6" :class="{error:errors.has('contactForm.email')}">
									        <span class="required" v-if="contactForm.email === ''">*</span>
									        <input type="email" class="form-control" id="email" maxlength='100' name='email' placeholder="Email" v-validate="'required|email'" v-model="contactForm.email">
									        <span class="message-error" v-show="errors.has('contactForm.Email')" >{{ errors.first('contactForm.Email') }}</span>
									      </div>
									    </div>

									    <div class="form-row">
									      <div class="form-group col-md-6" :class="{error:errors.has('contactForm.phone')}">
									        <span class="required" v-if="contactForm.phone === ''">*</span>
									        <input type="text" class="form-control" id="phone" maxlength='100' name='phone' placeholder="Phone" v-validate="'required'" v-model="contactForm.phone">
									        <span class="message-error" v-show="errors.has('contactForm.phone')" >{{ errors.first('contactForm.phone') }}</span>
									      </div>
									      <div class="form-group col-md-6" :class="{error:errors.has('contactForm.url')}">
									        <input type="text" class="form-control" id="url" maxlength='100' name='url' placeholder="Website" v-model="contactForm.url">
									        <span class="message-error" v-show="errors.has('contactForm.url')" >{{ errors.first('contactForm.url') }}</span>
									      </div>
									    </div>

											<div class="form-row">
												<div class="form-group col-sm-6 col-md-12 col-lg-6">
													<vue-recaptcha @verify="markRecaptchaAsVerifiedContact" class="captcha" sitekey="6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"></vue-recaptcha>

													<div class="captcha-error">
														<p class="text-small">{{ contactForm.pleaseTickRecaptchaMessage }}</p>
													</div>
												</div>
												<div class="form-group col-sm-6 col-md-12 col-lg-6 text-right" :class="{error:errors.has('contactForm.Email')}">
													<button type="submit" tag="button" class="btn_orange gtm_buttonCX2_contactformsubmit">Schedule the presentation</button>
												</div>
											</div>

											<div class="clearfix"></div>

											<div v-if="contactForm.formSubmitted" :class="[contactForm.formSubmitted ? 'thank-message fadeIn' : '']">
												<div class="row" v-in-viewport="">
													<div class="col-xs-12">
														<p class="text-center">Ok, you’ve taken the first step. We’ll get back to you within one business day.</p>
													</div>
												</div>
											</div>

										</form>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Do it With me -->
		<section id="section" class="DIWM_section-block DIWM_doitwithme container-fluid col-xs-12" v-in-viewport="">
			<div class="inside">
				<div class="row">
					<h2 class="text-center" v-in-viewport="">
						Here are just a few key findings from the research that may offer insight into connecting with Millennials:
					</h2>
				</div>

				<!-- Item 1 -->
				<div class="row item">

					<div class="col-sm-6 col-lg-3 col-lg-offset-1 image">
						<img @click="savePDFfile('mti16284-1_DIWM1_V04LO_20190906.pdf')"  src="/dist/mti16284-1_DIWM1_V04LO_20190906.png" alt="">
					</div>

					<div class="col-sm-6 col-lg-7 infomation">
						<h3>Millennials: The most misunderstood demographic in the DIY space.</h3>
						<p>
							The Millennial DIY story is a story of contradictions. Millennials actually have experience working on home projects with their parents. They actually shop online and in store. They don’t know everything, but they aren’t afraid to ask friends, family, YouTubers and in-store associates for advice. That said, fewer Millennial homeowners hire professionals (just 13%) because they think they’ll get the runaround or get  hustled.
						</p>
						<button @click="savePDFfile('mti16284-1_DIWM1_V04LO_20190906.pdf')" target="_blank" class="btn_orange">Download Infographic</button>
					</div>

				</div>


				<!-- Item 2 -->
				<div class="row item">

					<div class="col-sm-6 col-lg-3 col-lg-offset-1 image">
						<img @click="savePDFfile('mti16284-1_DIWM3_V04LO_20190906.pdf')"  src="/dist/mti16284-1_DIWM3_V04LO_20190906.png" alt="">
					</div>

					<div class="col-sm-6 col-lg-7 infomation">
						<h3>Millennials do home improvement, but they don’t do it alone.</h3>
						<p>
							Millennials spend more time taking trips to stores when working on DIY projects than older generations do. One in four (23%) Millennials say that, sometimes, they spend more time making trips to the store for a home improvement project than they do working on the project itself! (vs. 12% of Gen Xers and 10% of Boomers)
						</p>


						<!-- <h3>Millennials are more confident, but less prepared.</h3>
						<p>
							Millennials are brave when it comes to home improvement. In fact, 56% of them said they did their first home project DIY. (That said, 52% said they didn’t have all the tools supplies and materials they needed before they started.)
						</p> -->
						<button @click="savePDFfile('mti16284-1_DIWM3_V04LO_20190906.pdf')" target="_blank" class="btn_orange">Download Infographic</button>
					</div>

				</div>

				<!-- Item 3 -->
				<div class="row item">

					<div class="col-sm-6 col-lg-3 col-lg-offset-1 image">
						<img @click="savePDFfile('mti16284-1_DIWM4_V04LO_20190906.pdf')"  src="/dist/mti16284-1_DIWM4_V04LO_20190906.png" alt="">
					</div>

					<div class="col-sm-6 col-lg-7 infomation">
						<h3>Millennials are more confident, but less prepared.</h3>
						<p>
							Millennials are brave when it comes to home improvement. In fact, 56% of them said they did their first home project DIY. (That said, 52% said they didn’t have all the tools supplies and materials they needed before they started.)
						</p>

						<!-- <h3>Millennials do more home improvement than their parents.</h3>
						<p>
							Just when you thought it was all snack foods and video games, it turns out Millennials love their home improvement. They take more pride in their home improvement than just about anything else they do. They’ll even call in sick to work on a DIY project. Who knew?
						</p> -->
						<button @click="savePDFfile('mti16284-1_DIWM4_V04LO_20190906.pdf')" target="_blank" class="btn_orange">Download Infographic</button>
					</div>

				</div>

				<!-- Item 4 -->
				<div class="row item">

					<div class="col-sm-6 col-lg-3 col-lg-offset-1 image">
						<img @click="savePDFfile('mti16284-1_DIWM2_V04LO_20190906.pdf')"  src="/dist/mti16284-1_DIWM2_V04LO_20190906.png" alt="">
					</div>

					<div class="col-sm-6 col-lg-7 infomation">
						<h3>Millennials do more home improvement than their parents.</h3>
						<p>
							Just when you thought it was all snack foods and video games, it turns out Millennials love their home improvement. They take more pride in their home improvement than just about anything else they do. They’ll even call in sick to work on a DIY project. Who knew?
						</p>

						<!-- <h3>Millennials do home improvement, but they don’t do it alone.</h3>
						<p>
							Millennials spend more time taking trips to stores when working on DIY projects than older generations do. One in four (23%) Millennials say that, sometimes, they spend more time making trips to the store for a home improvement project than they do working on the project itself! (vs. 12% of Gen Xers and 10% of Boomers)
						</p> -->
						<button @click="savePDFfile('mti16284-1_DIWM2_V04LO_20190906.pdf')" target="_blank" class="btn_orange">Download Infographic</button>
					</div>

				</div>

			</div>

		</section>

		<!-- Do it With me -->
		<section id="about" class="DIWM_section-block DIWM_about container-fluid col-xs-12" v-in-viewport="">
			<div class="inside">
				<div class="row">
					<h3 class="text-center" v-in-viewport="">
						About Marcus Thomas
					</h3>
					<p>
						Marcus Thomas is a 221-person full-service agency based in Cleveland, Ohio. The agency has deep understanding of the home and garden segment and its hardware, big box and ecommerce channel partners.
					</p>

					<div class="col-xm-12 brand-container">
						<img alt="Behr" src="/dist/behr.svg">
						<img alt="Behr" src="/dist/kraftmaid.svg">
						<img alt="Behr" src="/dist/troy-bilt.svg">
						<img alt="Behr" src="/dist/kichler.svg">
						<img alt="Behr" src="/dist/moen.svg">
					</div>

				</div>
			</div>
		</section>
		
		<!-- Footer -->
		<Footer></Footer>
	</div>
</template>



<script>
	import seoModule from '../mixins/seoModule.js';
	import VueRecaptcha from 'vue-recaptcha';
	import hero from '../components/hero.vue';
	import Footer from '../layout/footer-component.vue';
	import FileSaver from 'file-saver/FileSaver';



	//require('	data/home.json');
	require('../assets/img/doitwithme-hero.jpg');
	require('../assets/img/CLE-Image.jpg');
	require('../assets/img/hero-mobile.png');
	require('../assets/img/cx2.png');

	require('../assets/img/mti16284-1_DIWM1_V04LO_20190906.png');
	require('../assets/img/mti16284-1_DIWM2_V04LO_20190906.png');
	require('../assets/img/mti16284-1_DIWM3_V04LO_20190906.png');
	require('../assets/img/mti16284-1_DIWM4_V04LO_20190906.png');

	// //PDF
	// require('../assets/pdf/mti16284-1_DIWM1_V04LO_20190906.pdf');
	// require('../assets/pdf/mti16284-1_DIWM2_V04LO_20190906.pdf');
	// require('../assets/pdf/mti16284-1_DIWM3_V04LO_20190906.pdf');
	// require('../assets/pdf/mti16284-1_DIWM4_V04LO_20190906.pdf');


	//Brands
	require('../assets/img/troy-bilt.svg');
	require('../assets/img/kraftmaid.svg');
	require('../assets/img/behr.svg');
	require('../assets/img/kichler.svg');
	require('../assets/img/moen.svg');
	// require('../assets/img/crm-market.svg');
	// require('../assets/img/web-mobile-dev.svg');
	// require('../assets/img/ux-design.svg');
	// require('../assets/img/plus.svg');



	//Partners
	// require('../assets/img/partners/mural.png');
	// require('../assets/img/partners/sketch.png');
	// require('../assets/img/partners/invision.png');
	// require('../assets/img/partners/optimal.png');
	// require('../assets/img/partners/jira.png');


	// require('../assets/img/partners/kentico.png');
	// require('../assets/img/partners/sitecore.png');
	// require('../assets/img/partners/sitefinity.png');
	// require('../assets/img/partners/salesforce.png');
	// require('../assets/img/partners/google-cloud.png');
	//
	// require('../assets/img/partners/troy-bilt.png');
	// require('../assets/img/partners/fanatics.png');
	// require('../assets/img/partners/ibm.png');
	// require('../assets/img/partners/key-bank.png');
	// require('../assets/img/partners/cu.png');
	//
	// require('../assets/img/partners/momentive.png');
	// require('../assets/img/partners/oh-lottery.png');
	// require('../assets/img/partners/maritz.png');
	// require('../assets/img/partners/assurant.png');
	// require('../assets/img/partners/firstenergy.png');

	export default{
		name:'Home',
		data () {
			return {
				pageHome: [],
				works: [],
				words:[],
				modularContent:[],
				contactForm: {
					recaptchaVerified: false,
					pleaseTickRecaptchaMessage: '',
					firstname:'',
					lastname:'',
					company: '',
					email: '',
					campaign: '',
					phone: '',
					url: '',
					formSubmitted: false,
					checkBoxSelected : true
				},
				journeyForm: {
					recaptchaVerified: false,
					pleaseTickRecaptchaMessage: '',
					firstname:'',
					lastname:'',
					company: '',
					email: '',
					campaign: '',
					formSubmitted: false
				}
			}
		},
		created:function(){
			this.loadDoItWithMeData();
		},
		mounted: function() {

			if (typeof this.$route.query.utm_campaign !== 'undefined' && this.$route.query.utm_campaign !== ''){
				this.contactForm.campaign = this.$route.query.utm_campaign;
				//this.journeyForm.campaign = this.$route.query.utm_campaign;
			}

			setTimeout(function(){

				$('.toggle-icon').on('click' ,function () {
					var text = $(this).siblings('.info').children('ul');

					if (text.is(':hidden')) {
						text.slideDown('200');
						$(this).children('span').addClass('opened');
					} else {
						text.slideUp('200');
						$(this).children('span').removeClass('opened');
					}

				});

				$('.inner-icons .label span').on('click' ,function () {

					var text = $(this).closest('.inner-icons').find('.info').children('ul');

					if (text.is(':hidden')) {
						text.slideDown('200');
						$(this).closest('.inner-icons').find('.toggle-icon > span').addClass('opened');
					} else {
						text.slideUp('200');
						$(this).closest('.inner-icons').find('.toggle-icon > span').removeClass('opened');
					}

				});


				//Contact GTM Events
				$('form#contactForm .form-control').each(function(){
					$(this).focus(function(e){
						var n = $(this).attr('name');
						dataLayer.push({'event': 'Contact Us Form', 'fieldname': n });
					});
				});
				$('form#contactForm .form-check-input').each(function(){
					$(this).focus(function(e){
						var n = $(this).next('label').text();
						dataLayer.push({'event': 'Contact Us Form', 'checkbox': n });

					});
				});
				$('form#contactForm textarea.track-it').focus(function(e){
					var n = $(this).attr('name');
					dataLayer.push({'event': 'Contact Us Form', 'fieldname': n });
				});


			},500);
		},
		methods: {
			loadDoItWithMeData() {
				this.$http.get("/src/data_jsons/doitwithme_2.json").then((response) => {
					this.pageHome = response.body.items[0];
					this.modularContent = response.body.modular_content;
					
					// Show footer after loading data
					setTimeout(function () {
						$("#footer").show();
					}, 500);
				});
			},
			webToLead(fields,scope) {
        var customHiddenIframeName='JLA_API';
        if(!document.getElementById(customHiddenIframeName)){
          var theiFrame=document.createElement("iframe");
          theiFrame.id=customHiddenIframeName;
          theiFrame.name=customHiddenIframeName;
          theiFrame.src='about:blank';
          theiFrame.style.display='none';
          document.body.appendChild(theiFrame);
        }
        fields['retURL']='http://127.0.0.1';//dummy URL
        var form = document.createElement("form");
        form.method = "POST";
        form.action = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
        form.setAttribute("target", customHiddenIframeName);
        for (var fieldName in fields) {
          var theInput = document.createElement("input");
          theInput.name=fieldName;
          theInput.value=fields[fieldName];
          theInput.setAttribute("type", "hidden");
          form.appendChild(theInput);
        }
        document.body.appendChild(form);
        form.submit();
        this.contactForm.formSubmitted=true;
        let _this = this;

        setTimeout(function(){
  				_this.resetForm(scope);

  			}, 300);

        setTimeout(function(){
          _this.contactForm.formSubmitted=false;
  			}, 5000);

      },
			savePDFfile(file){
				this.$http.get(file,{responseType: 'arraybuffer'}).then((response) => {
					var newBlob = new Blob([response.data], {type:"application/pdf"})
					FileSaver.saveAs(newBlob, file);
				})
			},

			openJourney() {
				var elem = document.getElementById("your-journey");
				elem.classList.add("opened");
				elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;

				setTimeout(function(){
					if (window.screen.width <= 768) {
						document.getElementById("your-journey").scrollIntoView({block: "start", behavior: "smooth"});
					}
					else {
						document.getElementById("your-journey").scrollIntoView({block: "end", behavior: "smooth"});
					}
					window.onresize = function(event) {
						elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
					};
				},300);
			},
			markRecaptchaAsVerifiedJourney(response) {
				this.journeyForm.pleaseTickRecaptchaMessage = '';
				this.journeyForm.recaptchaVerified = true;
			},
			markRecaptchaAsVerifiedContact(response) {
				this.contactForm.pleaseTickRecaptchaMessage = '';
				this.contactForm.recaptchaVerified = true;
			},
			resetForm(scope) {
				this.$validator.pause();

				if(scope=='contactForm'){
					this.contactForm.recaptchaVerified = false;
					this.contactForm.pleaseTickRecaptchaMessage = '';
					this.contactForm.firstname = '';
					this.contactForm.lastname = '';
					this.contactForm.company = '';
					this.contactForm.email = '';
					this.contactForm.phone = '';
					this.contactForm.url = '';
					this.contactForm.checkBoxSelected = true;
				}

				if(scope=='journeyForm'){
					this.journeyForm.recaptchaVerified = false;
					this.journeyForm.pleaseTickRecaptchaMessage = '';
					this.journeyForm.firstname = '';
					this.journeyForm.lastname = '';
					this.journeyForm.company = '';
					this.journeyForm.email = '';
				}

				this.$validator.errors.clear();
				this.$validator.reset();
				document.getElementById(scope).reset();
			},
			validateForm(scope) {
				this.$validator.resume();
				const dict = {
					custom: {
						'Email': {
							required: 'This is a required field.',
							email: 'Please enter a validate email address'
						},
						'Last Name': {
							required: 'This is a required field.',
						},
						'First Name': {
							required: 'This is a required field.',
						},
						'Company': {
							required: 'This is a required field.',
						},
						'Phone': {
							required: 'This is a required field.',
						}
					}
				};
				this.$validator.localize('en', dict);
				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						//Check scope
						var formData = new FormData(document.getElementById(scope));
						var myForm;

						if(scope=='contactForm'){
							myForm = this.contactForm;
							if (!this.contactForm.recaptchaVerified) {
								this.contactForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
								return true; // prevent form from submitting
							}

						}

						if(scope=='journeyForm'){
							myForm = this.journeyForm;
							if (!this.journeyForm.recaptchaVerified) {
								this.journeyForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
								return true; // prevent form from submitting
							}
						}


						this.webToLead({
              //Debug mode
              // debug:1,
              // debugEmail:'psapir@devsutd.com',

              oid         : '00D6A0000038T85',
              first_name  : myForm.first_name,
              last_name   : myForm.last_name,
              email       : myForm.email,
              company     : myForm.company,
              lead_source : myForm.lead_source,
							lead_source : 'Website',
              Campaign_ID : '7013u0000007aSHAAY',
              phone : myForm.phone,
							url : myForm.url
            }, scope);

						return false;
					}
				});
			},
		},
		components:{
			'hero':hero,
			'Footer':Footer,
			VueRecaptcha
		},
		mixins:[seoModule]
	}
</script>



// WEBPACK FOOTER //
// DoItWithMe.vue?722e6554